import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import { config } from "../config/config";
import { Token } from "../stores/slices/authSlice";
import { redactTokenId } from "./redactTokenId";

export const bugsnagStart: VoidFunction = () => {
  if (config.bugsnagApiKey) {
    Bugsnag.start({
      apiKey: config.bugsnagApiKey,
      onBreadcrumb: (breadcrumb) => {
        if (
          breadcrumb.type === "request" &&
          typeof breadcrumb.metadata.url === "string"
        ) {
          breadcrumb.metadata.url = redactTokenId(breadcrumb.metadata.url);
        }
      },
      plugins: [new BugsnagPluginReact()],
      // Backstop for anything that still lands in event or breadcrumb metadata
      // (TW-1144): tokens, passwords, secrets, auth headers and one-time hand-off codes.
      redactedKeys: [/token/i, /password/i, /secret/i, /authorization/i, /^code$/i],
    });
    BugsnagPerformance.start({
      apiKey: config.bugsnagApiKey,
      networkRequestCallback: (requestInfo) => ({
        ...requestInfo,
        url: requestInfo.url && redactTokenId(requestInfo.url),
      }),
    });
  }
};

export const bugsnagNotify: typeof Bugsnag.notify = (...args) => {
  if (config.bugsnagApiKey) {
    Bugsnag.notify(...args);
  }
};

const getTokenFingerprint = async (tokenId: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(tokenId)
  );
  return Array.from(new Uint8Array(digest).slice(0, 8), (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");
};

export const bugsnagUseToken = async ({
  firstName,
  lastName,
  tokenId,
}: Token): Promise<void> => {
  if (config.bugsnagApiKey) {
    Bugsnag.setUser(
      window.crypto?.subtle ? await getTokenFingerprint(tokenId) : undefined,
      "",
      [firstName, lastName].filter(Boolean).join(" ")
    );
  }
};
